module.exports = __webpack_public_path__ + "static/media/blackUploadIcon.a1b366a1.svg";